<template>
    <b-modal :title="'বসতবাড়ী হোল্ডিং নিবন্ধন করুন'" hide-footer size="lg" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="updateHolding">
            <div class="content_row">
                <h3>খানা প্রধানের তথ্য</h3>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="name" class="col-sm-12 col-form-label">নাম <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="name" type="text" v-validate="'required'" v-model="editHoldingForm.name"  class="form-control">
                                <p v-show="errors.has('name') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="father_name" class="col-sm-12 col-form-label">পিতা/স্বামীর নাম <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="father_name" type="text" v-validate="'required'" v-model="editHoldingForm.father_name" class="form-control">
                                <p v-show="errors.has('father_name') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="mother_name" class="col-sm-12 col-form-label">মাতার নাম <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="mother_name" type="text" v-validate="'required'" v-model="editHoldingForm.mother_name" class="form-control">
                                <p v-show="errors.has('mother_name') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="gender" class="col-sm-12 col-form-label">লিঙ্গ <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.gender" name="gender" v-validate="'required'" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="male">পুরুষ</option>
                                    <option value="female">মহিলা</option>
                                    <option value="others">অন্যান্য</option>
                                </select>
                                <p v-show="errors.has('gender') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="material_status" class="col-sm-12 col-form-label">বৈবাহিক অবস্থা <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.material_status" v-validate="'required'" name="material_status" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="married">বিবাহিত</option>
                                    <option value="unmarried">অবিবাহিত</option>
                                </select>
                                <p v-show="errors.has('material_status') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="dob" class="col-sm-12 col-form-label">জন্ম তারিখ</label>
                            <div class="col-sm-12">
                                <input type="date" name="dob" v-model="editHoldingForm.dob" class="form-control"  placeholder="জন্ম তারিখ">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="nid" class="col-sm-12 col-form-label">এনআইডি/জন্ম নিবন্ধন নম্বর <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="nid" type="text" v-validate="'required'" v-model="editHoldingForm.nid" class="form-control">
                                <p v-show="errors.has('nid') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="mobile" class="col-sm-12 col-form-label">মোবাইল <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="mobile" type="text" placeholder="01846XXXXXX" v-validate="'required'" v-model="editHoldingForm.mobile" class="form-control">
                                <p v-show="errors.has('mobile') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="religion" class="col-sm-12 col-form-label">ধর্ম <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.religion" v-validate="'required'" name="religion" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="Islam">ইসলাম</option>
                                    <option value="Hindu">হিন্দু</option>
                                    <option value="Christian">খ্রিষ্টান</option>
                                    <option value="Buddhist">বৌদ্ধ</option>
                                </select>
                                <p v-show="errors.has('religion') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="family_type" class="col-sm-12 col-form-label">পরিবারের শ্রেণী <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.family_type" v-validate="'required'" name="family_type" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="poor">দরিদ্র</option>
                                    <option value="MiddleClass">মধ্যবিত্ত</option>
                                    <option value="UpperMiddleClass">উচ্চ মধ্যবিত্ত</option>
                                </select>
                                <p v-show="errors.has('family_type') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="family_man" class="col-sm-12 col-form-label">পরিবারের জনসংখ্যা (পুরুষ) <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="family_man" type="text" placeholder="পরিবারের জনসংখ্যা (পুরুষ)" v-validate="'required'" v-model="editHoldingForm.family_man" class="form-control">
                                <p v-show="errors.has('family_man') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="family_woman" class="col-sm-12 col-form-label">পরিবারের জনসংখ্যা (মহিলা) <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="family_woman" type="text" placeholder="পরিবারের জনসংখ্যা (মহিলা)" v-validate="'required'" v-model="editHoldingForm.family_woman" class="form-control">
                                <p v-show="errors.has('family_woman') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content_row">
                <h3>ঠিকানার তথ্য</h3>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="ward" class="col-sm-12 col-form-label">ওয়ার্ড নং <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.ward" v-validate="'required'" name="ward" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="1">১</option>
                                    <option value="2">২</option>
                                    <option value="3">৩</option>
                                    <option value="4">৪</option>
                                    <option value="5">৫</option>
                                    <option value="6">৬</option>
                                    <option value="7">৭</option>
                                    <option value="8">৮</option>
                                    <option value="9">৯</option>
                                    <option value="10">১০</option>
                                    <option value="11">১১</option>
                                    <option value="12">১২</option>
                                    <option value="13">১৩</option>
                                    <option value="14">১৪</option>
                                    <option value="15">১৫</option>
                                </select>
                                <p v-show="errors.has('ward') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="village" class="col-sm-12 col-form-label">গ্রাম <span class="required">*</span></label>
                            <div class="col-sm-12">
                                 <select class="form-control" name="village" v-validate="'required'" v-model="editHoldingForm.village">
                                    <option value="">নির্বাচন করুন</option>
                                    <option v-for="(village,index) in villageLists" :key="index" :value="village.id">{{village.name_bn}}</option>
                                </select>
                                <p v-show="errors.has('village') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="holding_no" class="col-sm-12 col-form-label">হোল্ডিং নং <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="holding_no" type="text" placeholder="হোল্ডিং নং" v-validate="'required'" v-model="editHoldingForm.holding_no" class="form-control">
                                <p v-show="errors.has('holding_no') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="post_code" class="col-sm-12 col-form-label">পোস্ট কোড <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="post_code" type="text" placeholder="পোস্ট কোড" v-validate="'required'" v-model="editHoldingForm.post_code" class="form-control">
                                <p v-show="errors.has('post_code') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="post_office" class="col-sm-12 col-form-label">ডাকঘর <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <input name="post_office" type="text" placeholder="ডাকঘর" v-validate="'required'" v-model="editHoldingForm.post_office" class="form-control">
                                <p v-show="errors.has('post_office') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="elec_beneficiary" class="col-sm-12 col-form-label">বিদ্যুত সুবিধাভোগী কিনা <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.elec_beneficiary" v-validate="'required'" name="elec_beneficiary" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="1">হ্যা</option>
                                    <option value="0">না</option>
                                </select>
                                <p v-show="errors.has('elec_beneficiary') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="sanitation_info" class="col-sm-12 col-form-label">স্যানিটেশনের তথ্য <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.sanitation_info" v-validate="'required'" name="sanitation_info" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="pucca">পাকা</option>
                                    <option value="raw">কাচা</option>
                                </select>
                                <p v-show="errors.has('sanitation_info') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <div class="content_row">
                <h3>অন্যান্য তথ্য</h3>
                <vue-cloneya :minimum="1" :maximum="5" :multiple="true" v-model="editHoldingForm.house_lists">
                    <div class="cont">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group row">
                                    <label for="holding_type" class="col-sm-12 col-form-label">বাড়ির ধরন <span class="required">*</span></label>
                                    <div class="col-sm-12">
                                        <select v-cloneya-input="'holding_type'" v-validate="'required'" name="holding_type" class="form-control">
                                            <option value="">নির্বাচন করুন</option>
                                            <option value="raw">কাচা</option>
                                            <option value="pucca">পাকা</option>
                                            <option value="semiPucca">আধাপাকা</option>
                                            <option value="tinshed">টিনশেড</option>
                                            <option value="others">অন্যান্য</option>
                                        </select>
                                        <p v-show="errors.has('holding_type') && status" class="required">
                                            This is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group row">
                                    <label for="room_count" class="col-sm-12 col-form-label">রুম পরিমান <span class="required">*</span></label>
                                    <div class="col-sm-12">
                                        <input name="room_count" min=1 type="number" placeholder="রুম পরিমান" v-validate="'required'" v-cloneya-input="'room_count'" class="form-control">
                                        <p v-show="errors.has('room_count') && status" class="required">
                                            This is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group row">
                                    <label for="room_length" class="col-sm-12 col-form-label">দৈর্ঘ্য <span class="required">*</span></label>
                                    <div class="col-sm-12">
                                        <input name="room_length" type="text" placeholder="দৈর্ঘ্য" v-validate="'required'" v-cloneya-input="'room_length'" class="form-control">
                                        <p v-show="errors.has('room_length') && status" class="required">
                                            This is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group row">
                                    <label for="room_width" class="col-sm-12 col-form-label">প্রস্থ <span class="required">*</span></label>
                                    <div class="col-sm-12">
                                        <input name="room_width" type="text" placeholder="প্রস্থ" v-validate="'required'" v-cloneya-input="'room_width'" class="form-control">
                                        <p v-show="errors.has('room_width') && status" class="required">
                                            This is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group row">
                                    <label for="how_floors" class="col-sm-12 col-form-label">কত তলা <span class="required">*</span></label>
                                    <div class="col-sm-12">
                                        <input name="how_floors" min="1" type="number" placeholder="কত তলা" v-validate="'required'" v-cloneya-input="'how_floors'" class="form-control">
                                        <p v-show="errors.has('how_floors') && status" class="required">
                                            This is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="input-group-btn mb-2" align="right">
                            <button type="button" class="btn btn-danger mr-2" tabindex="-1"  v-cloneya-remove>
                            <i class="fa fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-success" tabindex="-1" v-cloneya-add>
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </vue-cloneya>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="annual_val" class="col-sm-12 col-form-label">বাড়ির বার্ষিক মান <span class="required">*</span></label>
                            <div class="col-sm-12">
                                 <input name="annual_val" min="1" type="number" placeholder="0" v-validate="'required'" v-model="editHoldingForm.annual_val" class="form-control">
                                <p v-show="errors.has('annual_val') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="annual_tax" class="col-sm-12 col-form-label">বার্ষিক কর <span class="required">*</span></label>
                            <div class="col-sm-12">
                                 <input name="annual_tax" min="1" type="number" placeholder="0" v-validate="'required'" v-model="editHoldingForm.annual_tax" class="form-control">
                                <p v-show="errors.has('annual_tax') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="occupation" class="col-sm-12 col-form-label">পেশা <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.occupation" v-validate="'required'" name="occupation" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="চাকুরী">চাকুরী</option>
                                    <option value="কৃষি কাজ">কৃষি কাজ</option>
                                    <option value="দিন মজুর">দিন মজুর</option>
                                    <option value="তাঁতী">তাঁতী</option>
                                    <option value="শিক্ষক">শিক্ষক</option>
                                    <option value="চিকিৎসক">চিকিৎসক</option>
                                    <option value="মেডিক্যাল কর্মী">মেডিক্যাল কর্মী</option>
                                    <option value="প্রবাসী কর্মী">প্রবাসী কর্মী</option>
                                    <option value="ব্যবসা">ব্যবসা</option>
                                    <option value="পরিবহণ শ্রমিক">পরিবহণ শ্রমিক</option>
                                    <option value="বেসরকারী চাকুরী">বেসরকারী চাকুরী</option>
                                    <option value="নির্মাণ শ্রমিক">নির্মাণ শ্রমিক</option>
                                    <option value="সরকারী চাকুরী">সরকারী চাকুরী</option>
                                    <option value="অন্যান্য">অন্যান্য</option>
                                </select>
                                <p v-show="errors.has('occupation') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group row">
                            <label for="last_tax_year" class="col-sm-12 col-form-label">সর্বশেষ ট্যাক্স পরিশোধ অর্থবছর <span class="required">*</span></label>
                            <div class="col-sm-12">
                                <select v-model="editHoldingForm.last_tax_year" v-validate="'required'" name="last_tax_year" class="form-control">
                                    <option value="">নির্বাচন করুন</option>
                                    <option value="2021/22">২০২১/২২</option>
                                    <option value="2022/23">২০২২/২৩</option>
                                </select>
                                <p v-show="errors.has('last_tax_year') && status" class="required">
                                    This is required
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
             <div class="form-group row">
                <div class="col-sm-12">
                    <input v-if="!addLoader" type="submit" value="Submit" class="btn btn-primary pull-right"/>
                    <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Submitting...
                    </button>
                    <button v-if="!addLoader" @click.prevent="close" class="btn btn-success pull-right"
                            style="margin-right:5px;">Close
                    </button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import { VueEditor } from 'vue2-editor'
    import axios from 'axios'
    export default {
        name: "editHoldingModal",
        data(){
            return{
                largeModal:false,
                addLoader: false,
                index:'',
                editHoldingForm:{
                    id:'',
                    name: '',
                    father_name: '',
                    mother_name: '',
                    gender: '',
                    material_status: '',
                    dob: '',
                    nid: '',
                    mobile: '',
                    religion: '',
                    family_type: '',
                    family_woman: '',
                    family_man: '',
                    ward: '',
                    village: '',
                    holding_no: '',
                    post_code: '',
                    post_office: '',
                    elec_beneficiary: '',
                    sanitation_info: '',
                    house_lists:[],
                    last_tax_year: '',
                    annual_val: '',
                    annual_tax: '',
                    occupation: ''
                }
            }
        },

        computed:{
            ...mapGetters(['modal','villageLists'])
        },
        mounted(){
            this.getVillageLists()
        },
        methods:{
            getVillageLists(){
                this.$store.dispatch('HOLDING_VILLAGE_LIST')
            },
            openModal(holding,index){
                //console.log(holding)
                self = this.editHoldingForm;
                this.largeModal = true
                this.index = index
                self.id = holding.id
                self.name = holding.name
                self.father_name = holding.father_name
                self.mother_name = holding.mother_name
                self.gender = holding.gender
                self.material_status = holding.material_status
                self.dob = holding.dob
                self.nid = holding.nid
                self.mobile = holding.mobile
                self.religion = holding.religion
                self.family_type = holding.family_type
                self.family_woman = holding.family_woman
                self.family_man = holding.family_man
                self.ward = holding.ward
                self.village = holding.village
                self.holding_no = holding.holding_no
                self.post_code = holding.post_code
                self.post_office = holding.post_office
                self.elec_beneficiary = holding.elec_beneficiary
                self.sanitation_info = holding.sanitation_info
                self.house_lists=[]
                holding.house_lists.map(function(value, key) {

                    self.house_lists.push({
                        holding_type: '',
                        room_count: '',
                        room_length: '',
                        room_width: '',
                        how_floors: '',
                    });
                    self.house_lists[key].holding_type = value.holding_type
                    self.house_lists[key].room_count = value.room_count
                    self.house_lists[key].room_length = value.room_length
                    self.house_lists[key].room_width = value.room_width
                    self.house_lists[key].how_floors = value.how_floors
                    // console.log(value)
                });
                self.last_tax_year = holding.last_tax_year
                self.annual_val = holding.annual_val
                self.annual_tax = holding.annual_tax
                self.occupation = holding.occupation
            },
            close(){
                this.largeModal = false
            },
            updateHolding(){
                this.addLoader=true
                var editForm = this.editHoldingForm
                var index = this.index
                this.$store.dispatch('UPDATE_HOLDING_REG_MARKET',{editForm,index})
                    .then(v=>{
                        this.addLoader = false
                        this.largeModal = false
                    })
            }
        }
    }

</script>

<style scoped>

    @import url('https://fonts.maateen.me/kalpurush/font.css');

    .content_row{ font-family: 'Kalpurush', sans-serif; margin-bottom: 20px;}
    .content_row h3{ font-size: 20px; text-decoration: underline; line-height: 25px;}
    .required{ color: red;}
</style>